export const getFranchisees = state => state.franchisees;

export const getQuery = state => state.query;

export const loading = state => state.loading;
